module.exports = __webpack_public_path__ + "static/media/upcoming-calls.591a858d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/upcoming-calls.svg
// module id = 872
// module chunks = 0